import BaseRepository from './base-repository';
import { TranslationEntity } from '@/types/Translation';
import { LanguageEntity } from '@/types/Language';

interface TranslationsListResponse {
   languages: LanguageEntity[];
   translations: TranslationEntity[];
}

export default class TranslationRepository extends BaseRepository<TranslationEntity, {}, TranslationsListResponse> {
   constructor() {
      super('/clfinder', 'key');
   }

   // public load(params: Nullable<{}>): Promise<TranslationsListResponse> {
   //    if (process.env.NODE_ENV !== 'production') {
   //       return new Promise((resolve) => {
   //          const translations: TranslationEntity[] = require('../mocks/translations.data.json');
   //          const languages: LanguageEntity[] = [];
   //          setTimeout(() => {
   //             resolve({translations, languages});
   //          }, 750);
   //       });
   //    }

   //    return super.load(params);
   // }
}
